export default {"src":"/_next/static/media/btdx.192471c8.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};